import * as S from "./standard-dialog.styles";
import {Formik, FormikHelpers, FormikProps} from "formik";
import {DynamicForm} from "@enter/support/src/components";
import React from "react";

import * as Yup from 'yup';
import {ClaimGuarantorResponsibility} from "../../../api";
import {InputField, ISelectOption} from "../../base";
import {StandardDialogButtonGroup} from "./standard-dialog.styles";
import {fields} from "@enter/support/src/pages/home/claims/claim-details/timeline/item/resources/hl7-parser/dictionary";

export interface IStandardDialogProps {
    schema: Yup.Schema<any>,
    initialValues: any,
    handleSubmit(response: any): void,
    handleCancel(): void,
    fields: IStandardDialogField[]
}

export interface IStandardDialogField {
    prop: string,
    type?: string,
    component?: React.ComponentType,
    label: string,
    maxLength?: number,
    options?: ISelectOption[]
}


export interface IStandardDialogButtonBarProps {
    className?: string;
    changed: boolean;
    cancelLabel?: string;
    saveLabel?: string;
    saveNotice?: string;
    stopLabel?: string;
    onCancel?: () => void;
    onError?: (traceId?: string) => void;
    onSave?: () => void;
    onStop?: () => Promise<boolean>;
    useNotify?: boolean;
}

export const StandardDialog = (props: IStandardDialogProps) => {

    const onSubmit = async (values: any, formik: FormikHelpers<any>) => {
        console.log("onSubmit called");

        formik.setSubmitting(true);

        try {
            await props.handleSubmit(values);
        } finally {
            formik.setSubmitting(false);
        }
    };

    return (
        <S.DialogBody>
            <Formik initialValues={props.initialValues} validationSchema={props.schema} onSubmit={onSubmit} validator={() => ({})}>
                {(formik: FormikProps<any>): React.ReactElement => (
                    <>
                        {
                            props.fields.map((item, index) => {
                                return <S.InputRow key={item.prop}>
                                    <S.InputAmount>
                                        <S.Label>{item.label}</S.Label>
                                        <S.FormField
                                            name={item.prop}
                                            maxLength={item.maxLength ? item.maxLength : 100}
                                            component={item.component ? item.component : InputField}
                                            options={item.options}
                                            type={item.type ? item.type : "text"}
                                        />
                                    </S.InputAmount>
                                </S.InputRow>
                            })
                        }
                        <S.StandardDialogButtonGroup
                            changed={true}
                            useNotify={false}
                            onCancel={props.handleCancel}
                            onSave={formik.submitForm}
                            saveLabel="Save"
                            saveNotice="Saved"
                        />
                    </>
                )}
            </Formik>
        </S.DialogBody>
    );
}